<template>
  <div ref="container" class="custom-cursor u-force-3d" />  
</template>

<script>
import { WebGL } from '@/webgl/WebGL'

export default {
  mounted () {
    this.webGL = new WebGL(this.$refs.container)

    window.addEventListener('mousemove', this.onMouseMove)
  },

  methods: {
    onMouseMove (event) {
      const pos = this.$device.getPointerPosition(event)
      this.webGL.setMousePos({
        x: ( pos.x / this.$device.width ) * 2 - 1,
        y: ( pos.y / this.$device.height ) * 2 - 1
      })
    }
  }
}
</script>

<style lang="stylus">
.custom-cursor
  height 100vh
  width 100%
  position fixed
  top 0
  left 0
  pointer-events none
</style>